import { render, staticRenderFns } from "./BattlesList.vue?vue&type=template&id=17f2f17b&"
import script from "./BattlesList.vue?vue&type=script&lang=js&"
export * from "./BattlesList.vue?vue&type=script&lang=js&"
import style0 from "./BattlesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports